{
  "de": {
    "nav": {
      "home": "Startseite",
      "back": "Zurück",
      "navigation": "Navigation",
      "ships": {
        "index": "Schiffe"
      },
      "compare": {
        "index": "Vergleichen",
        "ships": "Schiffe Vergleichen"
      },
      "manufacturers": "Hersteller",
      "images": "Bilder",
      "videos": "Videos",
      "shipHistory": "Historie",
      "hangar": {
        "index": "Mein Hangar",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventare",
        "vehicleCargo": "Fracht",
        "imports": "Importe",
        "transfers": "Transfers"
      },
      "login": "Anmelden",
      "logout": "Abmelden",
      "apiV1": "API v1",
      "apiV1Schema": "Schema",
      "apiV1Pagination": "Paginierung",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "Schema",
      "embed": "Einbettungswidget",
      "signUp": "Registrieren",
      "privacyPolicy": "Datenschutzerklärung",
      "impressum": "Impressum",
      "fleets": {
        "index": "Flotten",
        "add": "Neue Flotte erstellen",
        "invites": "Einladungen",
        "ships": "Schiffe",
        "members": {
          "index": "Mitglieder",
          "invites": "Einladungen",
          "worldmap": "Weltkarte",
          "starmap": "Sternenkarte"
        },
        "stats": "Statistiken",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "Missionen",
          "edit": {
            "details": "Details",
            "teams": "Teams & Slots"
          }
        },
        "events": {
          "index": "Events",
          "calendar": "Kalender",
          "edit": {
            "details": "Details",
            "schedule": "Termin",
            "signup": "Anmeldung",
            "teams": "Teams & Slots"
          },
          "payouts": "Auszahlungen"
        },
        "tours": "Touren",
        "settings": {
          "index": "Einstellungen",
          "fleet": "Flotteneinstellungen",
          "membership": "Mitgliedschaftseinstellungen",
          "roles": "Rollen",
          "notifications": "Benachrichtigungen",
          "discord": "Discord",
          "calendar": "Kalender",
          "features": "Funktionen",
          "contracts": "Aufträge"
        },
        "allies": "Verbündete",
        "contracts": {
          "index": "Aufträge"
        }
      },
      "rsiProfile": "RSI-Profil",
      "rsiHangar": "RSI-Hangar",
      "tools": {
        "index": "Werkzeuge",
        "travelTimes": "Reisezeiten",
        "cargoGrids": "Frachtgitter",
        "tours": "Touren"
      },
      "api": "API-Dokumentation",
      "stats": "Statistiken",
      "toggleSlimCollapse": "Zusammenklappen",
      "toggleSlimExpand": "Erweitern",
      "roadmap": {
        "index": "Roadmap",
        "overview": "Übersicht",
        "changes": "Änderungen",
        "ships": "Schiffe-Roadmap"
      },
      "rsiVerification": "RSI-Verifizierung",
      "settings": {
        "index": "Einstellungen",
        "profile": "Profil",
        "account": "Konto",
        "security": "Sicherheit",
        "notifications": "Benachrichtigungen",
        "calendar": "Kalender",
        "hangar": "Hangar",
        "privacy": "Datenschutz",
        "features": "Funktionen",
        "connections": "Verbindungen",
        "oauthApplications": "OAuth-Apps",
        "verify": "RSI-Kontoverifizierung",
        "friends": "Freunde"
      },
      "reload": "Update verfügbar!",
      "visualTests": {
        "index": "Visuelle Tests",
        "panels": "Bereiche",
        "buttons": "Schaltflächen",
        "events": "Events",
        "typography": "Typografie",
        "forms": "Formulare",
        "tables": "Tabellen",
        "lists": "Listen",
        "metrics": "Metriken",
        "states": "Zustände",
        "notifications": "Benachrichtigungen",
        "syncModal": "Sync-Modal",
        "overlays": "Overlays",
        "supportHint": "Support-Hinweis",
        "media": "Medien",
        "charts": "Diagramme",
        "chips": "Chips",
        "groups": {
          "foundations": "Grundlagen",
          "data": "Daten",
          "feedback": "Feedback"
        },
        "notificationCenter": "Benachrichtigungszentrale",
        "themes": "Themes"
      },
      "admin": {
        "index": "Admin",
        "models": {
          "index": "Modelle",
          "create": "Modell erstellen",
          "edit": {
            "index": "Basisdaten",
            "metrics": "Metriken",
            "prices": "Preise",
            "docks": "Andockplätze",
            "modules": "Module",
            "paints": "Lackierungen",
            "images": "Bilder",
            "videos": "Videos",
            "cargoAndFuel": "Fracht und Treibstoff",
            "cargoHolds": "Frachträume",
            "fleetchart": "Flottenkarten-Bilder",
            "positions": "Positionen",
            "hardpoints": "Aufhängungspunkte",
            "loaners": "Leihschiffe",
            "snubCrafts": "Snub Crafts",
            "upgrades": "Upgrades",
            "packages": "Pakete",
            "history": "Verlauf"
          }
        },
        "modelPaints": {
          "index": "Lackierungen",
          "create": "Lackierung erstellen"
        },
        "modelModules": {
          "index": "Module",
          "create": "Modul erstellen",
          "edit": {
            "index": "Basisdaten",
            "models": "Modelle",
            "prices": "Preise",
            "hardpoints": "Aufhängungspunkte",
            "docks": "Andockplätze",
            "cargoHolds": "Frachträume",
            "history": "Verlauf"
          }
        },
        "unlistedModels": {
          "index": "Nicht gelistete Schiffe"
        },
        "modelModulePackages": {
          "index": "Modulpakete",
          "create": "Modulpaket erstellen"
        },
        "components": {
          "index": "Komponenten",
          "edit": {
            "index": "Basisdaten",
            "prices": "Preise",
            "history": "Verlauf"
          }
        },
        "manufacturers": {
          "index": "Hersteller",
          "edit": {
            "index": "Basisdaten",
            "models": "Schiffe",
            "components": "Komponenten",
            "equipment": "Ausrüstung",
            "modules": "Module"
          }
        },
        "images": {
          "index": "Bilder"
        },
        "users": {
          "index": "Benutzer",
          "edit": "Bearbeiten",
          "fleets": "Flotten",
          "inventories": "Inventare"
        },
        "fleets": {
          "index": "Flotten",
          "edit": "Bearbeiten",
          "members": "Mitglieder",
          "history": "Verlauf",
          "roles": "Rollen",
          "inventories": "Inventare"
        },
        "destroyedFleets": {
          "index": "Gelöschte Flotten"
        },
        "vehicles": {
          "index": "Fahrzeuge"
        },
        "admins": {
          "index": "Administratoren"
        },
        "oauthApplications": {
          "index": "OAuth-Apps"
        },
        "maintenance": {
          "index": "Wartung",
          "pghero": "PG-Hero",
          "features": "Funktionen",
          "workers": "Worker",
          "tasks": "Aufgaben",
          "imports": "Importe",
          "rsiApiStatus": "RSI-API-Status",
          "buildCompare": "Build-Vergleich"
        },
        "supporterContributions": {
          "index": "Unterstützer-Beiträge",
          "new": "Neuer Beitrag",
          "edit": "Beitrag bearbeiten"
        },
        "fundingGoals": {
          "index": "Finanzierungsziele",
          "new": "Neues Finanzierungsziel",
          "edit": "Finanzierungsziel bearbeiten"
        },
        "notifications": {
          "index": "Benachrichtigungen"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "Visuelle Tests",
          "notifications": "Benachrichtigungen"
        },
        "groups": {
          "catalogue": "Katalog",
          "community": "Community",
          "people": "Personen",
          "system": "System"
        }
      },
      "notifications": "Benachrichtigungen",
      "scDataSource": "Datenquelle"
    }
  }
}
